<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">


<div class="">
              
  
  
  
    
  
  
    
  


  <div class="row affiliate">
    <div class="col-lg-12">
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li style="background:#eaeaea">
            <router-link :to="{name: 'affiliate'}" class="no-margins text-center"><i class="fa fa-fw fa-globe"></i> ภาพรวม</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_member'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-user-circle"></i> สมาชิก</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_revenue'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-money"></i> รายได้</router-link>
          </li>
          <li class="active">
            <router-link :to="{name: 'af_withdraw'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-bell"></i> แจ้งถอนรายได้</router-link>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active">
            <div class="panel-body p-xs">



              <div class="row">
              <div class="col-xs-12 text-center">
              <div class="alert alert-warning text-center" role="alert">รายได้ ระบบแนะนำ จะถอนเข้าเป็นเงินเครดิต หากสงสัยโปรดติดต่อเอเย่นต์ที่ท่านสมัครสมาชิก</div>
              </div>
              <form class="m-t form-horizontal fv-form fv-form-bootstrap" role="form" id="form-withdraw" @submit.prevent.once="processAfWithdraw" >

              <div class="col-xs-12 text-center">
                <h3>รายได้จากการแนะนำ : {{ fixDecimalValue(affiliate_balance) }} </h3>
              </div>
              <div class="form-group no-margins has-feedback">
              <div class="col-md-4 col-md-offset-4 m-b-sm">
                <div class="input-group">
                  <span class="input-group-addon">ต้องการถอน </span>
                  <input type="text" name="amount" class="form-control" :placeholder="'ระบุจำนวนเงิน (ขั้นต่ำ ' + amount_limit + ' บาท)'" id="amount" v-model="amount">
                </div><i class="form-control-feedback fv-bootstrap-icon-input-group" data-fv-icon-for="amount" style="display: none;"></i>
              <small class="help-block" data-fv-validator="notEmpty" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">โปรดระบุข้อมูลในส่วนนี้</small><small class="help-block" data-fv-validator="numeric" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">โปรดระบุเลขหน่วยหรือจำนวนทศนิยม ให้ถูกต้อง</small><small class="help-block" data-fv-validator="lessThan" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">โปรดระบุค่าน้อยกว่าหรือเท่ากับ %s</small><small class="help-block" data-fv-validator="greaterThan" data-fv-for="amount" data-fv-result="NOT_VALIDATED" style="display: none;">กรุณาระบุค่ามากกว่าหรือเท่ากับ %s</small></div>
              </div>
              <div class="col-md-4 col-md-offset-4 m-b-sm">
                <button class="btn btn-primary block full-width m-b" type="submit">แจ้งถอนรายได้</button>
              </div>
              </form>
              </div>

              <div class="row">
              <div class="col-xs-12">
              <table class="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>ลำดับที่</th>
                  <th>รายละเอียด</th>
                  <th class="text-left">จำนวนเงิน</th>
                  <th class="text-left">รายได้คงเหลือ</th>
                  <th class="text-left">วันที่ทำรายการ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in affiliate_ledger" :key="'al-' + index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.desc }}</td>
                  <td class="text-left">
                      <span class="text-negative" v-if="item.credit">-{{ fixDecimalValue(item.credit) }}</span>
                      <span class="text-positive" v-else>{{ fixDecimalValue(item.debit) }}</span> 
                  </td>
                  <td class="text-left">{{ fixDecimalValue(item.balance) }}</td>
                  <td class="text-left">{{ formatDate(item.created_at) }}</td>
                </tr>
              </tbody>
              <tfoot>
                  <tr>
                    <td colspan="100%">
                      <div class="text-primary-new m-b-sm">แสดงรายการย้อนหลัง 10 รายการล่าสุด</div>
                    </td>
                  </tr>
              </tfoot>
              
              </table>
              </div>
              </div>


            </div> <!-- /.ibox-content -->
          </div>
        </div> <!-- /.tab-content -->


      </div> <!-- /.tabs-container -->

    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->



            </div>


        </div>
      </div><!-- /#page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'af_withdraw',
    data () {
        return {
            affiliate_ledger: [],
            affiliate_balance: 0,
            amount: '',
            amount_limit: 1,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        })
    },
    methods: {
        async getAffiliateLedger () {
            try {

                const response = await this.$store.dispatch('affiliate/getAffiliateLedger', this.user.af_account_id )
                //console.log('async initial getAffiliateLedger', response)

                if ( response ) {
                    this.affiliate_ledger = response.ledger
                    this.affiliate_balance = response.balance
                    this.amount_limit = response.DEFAULT_AFF_LIMIT
                }

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
                //this.$router.push({name: 'login',})
            }
        },

        async processAfWithdraw () {
            //console.log('this amount', this.amount)

            if ( parseFloat(this.amount) >= this.amount_limit && parseFloat(this.amount) <= this.affiliate_balance && this.validateMoney(this.amount) ) {

                //let transaction_date = moment(new Date()).format('YYYY-MM-DD HH:mm')
                let withdrawData = {
                    af_account_id: this.user.af_account_id,
                    credit: this.amount,
                    desc: 'แจ้งถอนรายได้ผ่านเว็บ',
                    //status_id: 1,
                    //transaction_date: transaction_date,
                }
                //console.log('withdrawData', withdrawData)

                try {

                    // deduct balance
                    let remain_balance =  parseFloat(this.affiliate_balance) - parseFloat(this.amount)

                    if ( remain_balance >= 0 ) {
                        //console.log('processWithdraw remain_balance can withdraw', remain_balance)

                        const responseCreate = await this.$store.dispatch('affiliate/createAfWithdraw', withdrawData)
                        //console.log('createAfWithdraw responseCreate', responseCreate)

                        if ( responseCreate && responseCreate.data.message == 'SUCCESS' ) {
                            this.$toasted.success('ได้รับการแจ้งถอนแล้ว.')
                        }
                        else {
                            this.$toasted.error('ไม่สามารถทำรายการได้')
                        }
                        //this.$router.push({name: 'af_withdraw',})
                        //this.amount = ''
                        this.getAffiliateLedger()

                    }
                    else {
                        this.$toasted.info('จำนวนเครดิตของท่านคือ: ' + this.affiliate_balance)
                        //console.log('processWithdraw remain_balance cannot withdraw', remain_balance)
                        this.$toasted.error('จำนวนเงินที่แจ้งถอน มีจำนวนเกินเครดิตท่านเหลือ')
                    }

                } catch (error) {
                    //console.log('error', error)
                    this.$toasted.error('There was an error connecting to the server.')
                } finally {
                    this.$root.$emit('navbar')
                }

            }
            else {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง จำนวนเงินต้องมากกว่า 0 (ขั้นต่ำ ' + this.amount_limit +  ' บาท) หรือ ท่านแจ้งถอนเกินจำนวนเครดิตที่มี')
            }
            this.amount = ''

        },

        formatDate (value) {
            if (value) {
                let date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        validateMoney (amount) {
            let rgx = /^[0-9]+(\.[0-9]{1,2})?$/g
            return amount.match(rgx)
        },

        fixDecimalValue (value) {
            let af_amount = 0
            if (value) {
                af_amount = value
            }
            return this.formatMoney(af_amount.toFixed(2))
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

    },
    created () {
        //console.log('crypto')
        this.getAffiliateLedger()

    },
    destroyed () {
    },
    mounted () {
    },
}
</script>

<style lang="sass" scoped>
</style>
